import { IBaseResponse } from "@nkr/models/index";
import { AuthActionCreators } from "@nkr/store/authorization";
import { useAppHookContext } from "@nkr/utils/rest-api";
import { useEffect, useState } from "react";
import { IFinancialAgreement } from "..";

interface IRetVal {
    list: IFinancialAgreement[],
    loading: boolean,
    error: string,
}

function useFinancialAgreementData(centerId: number, donorId: number, recipientId: number): IRetVal {
    const { dispatch } = useAppHookContext();

    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');
    const [list, setList] = useState<IFinancialAgreement[]>([]);

    useEffect(() => {
        if (centerId && donorId && recipientId) {
            setLoading(true);
            setError('');

            const fetchData = async () => {
                let config = {
                    url: `${__API__}/file/${centerId}/financial-agreement-data?donorId=${donorId}&recipientId=${recipientId}`
                };

                try {
                    const response: IBaseResponse = await dispatch(AuthActionCreators.apiGet(config));

                    if (response && response.data.results && response.data.success) {
                        setList(response.data.results);
                    } else {
                        setError('Unable to load data');
                        setList([]);
                    }

                } catch (err) {
                    setList([]);
                    setError(err);
                } finally {
                    setLoading(false);
                }
            }

            fetchData();
        }
    }, [centerId, donorId, recipientId]);

    return { list, loading, error }
}

export default useFinancialAgreementData;